import AbstractConfig from "../../../core/config/AbstractConfig";
import DashboardDefinition from "./DashboardDefinition";

export default class DashboardConfig extends AbstractConfig {
    constructor() {
        super();

        this._savedDashboarConfig = null;
    }

    /**
     * @returns {Array<DashboardDefinition>}
     */
    get dashboard() {
        if (this._savedDashboarConfig) {
            return this._savedDashboarConfig;
        }

        const dashboardObj = this.getValue('dashboard');

        const dashboardDefinitions = [];
        for (const [key, value] of Object.entries(dashboardObj)) {
            const dashboardDefinition = new DashboardDefinition(
                key,
                value?.column,
                value?.localizedLabel,
                value?.greenTrendOnPositiveData,
            );
            dashboardDefinitions.push(dashboardDefinition);
        }

        this._savedDashboarConfig = dashboardDefinitions;
        return this._savedDashboarConfig;
    }
}
